'use strict';

angular.module('ClinicApp').config(function($stateProvider, authorizationProvider) {
  $stateProvider.state('reserved-slots-faq', {
    url: '/instant-book-faq/',
    templateUrl: '/views/reserved-slots-faq.html',
    controller: 'ReservedSlotFAQCtrl',
    data: {
      whiteBackground: true,
    },
    resolve: {
      auth: authorizationProvider.requireAuthorizedUser,
      pageTitle: function($pageTitle) {
        $pageTitle.set('Calendar - How It Works');
      },
    },
  });
});

angular.module('ClinicApp').controller('ReservedSlotFAQCtrl', function($scope) {

  $scope.images = {
    patientExperience: '/img/reserved-slots-faq/timeslots-ui.png',
    howToAdd: {
      1: '/img/reserved-slots-faq/timeslot-calendar.jpeg',
      2: '/img/reserved-slots-faq/timeslot-add.png',
      3: '/img/reserved-slots-faq/timeslot-delete.png',
    },
    howToConfirm: {
      1: '/img/reserved-slots-faq/appointment-organizer.png',
      2: '/img/reserved-slots-faq/appointment-manager.png',
    },
  };

  $scope.showScreenshot = function(url) {
    $scope.showScreenshotViewer = true;
    $scope.screenshotViewerUrl = url;
  };

  $scope.closeScreenshotViewer = function() {
    $scope.showScreenshotViewer = false;
  };
});
